import { snakeCase } from 'lodash-es'
import i18n from './i18n'

hasOwn = (object, key) ->
  Object::hasOwnProperty.call(object, key)

export default class Renderable
  @_i18nScope: null
  @_i18nScopeNamespace: null

  Object.defineProperty this, "i18nScope",
    get: ->
      return @_i18nScope if hasOwn(this, "_i18nScope") && @_i18nScope?

      scope = snakeCase(@name or "")
      if @i18nScopeNamespace then "#{@i18nScopeNamespace}.#{scope}" else scope
    set: (newValue) -> @_i18nScope = newValue

  Object.defineProperty this, "i18nScopeNamespace",
    get: -> @_i18nScopeNamespace
    set: (newValue) -> @_i18nScopeNamespace = newValue

  # Translate a key, leading "." triggers lazy lookup
  @t: (key, options) ->
    fullKey = if key?.charAt(0) is '.'
      "javascript.#{@i18nScope}#{key}"
    else
      key
    i18n.t(fullKey, options)

  # Instance translate — same behavior but keyed on the constructor.
  t: (key, options) =>
    fullKey = if key?.charAt(0) is '.'
      "javascript.#{@constructor.i18nScope}#{key}"
    else
      key
    i18n.t(fullKey, options)

  renderLocals: => { t: @t }

  render: -> throw new Error("#{@constructor.name}#render() not implemented")
